<template>
  <div class="note-video">
    <div class="title">{{ $route.query.name }}</div>
    <video controlsList="nodownload" :src="$route.query.url" controls></video>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.note-video {
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    padding: 0 10px;
    margin: 36px 0;
    min-height: 38px;
    line-height: 38px;
    color: #c77b29;
    font-size: 28px;
    text-align: center;
    word-break: break-all;
  }
  video {
    width: 90%;
  }
}
</style>
